import { useEffect, useRef, useState } from 'react';
import SearchInput from '../atoms/SearchInput';
import SortingMenu, { SortDirection, SortingType } from '../atoms/SortingMenu';
import { Menu } from 'lucide-react';

const SearchWithSorting = ({
  searchValue,
  onChangedSearch,
  sortConfig,
  sortItems,
  handleSortChange,
}: {
  searchValue?: string;
  onChangedSearch: (searchValue: string) => void;
  sortItems: SortingType[];
  sortConfig: { key: SortingType; direction?: SortDirection };
  handleSortChange: (type: SortingType) => void;
}) => {
  const [sortMenuOpen, setOpen] = useState(false);
  const sortingDropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sortingDropdownRef.current &&
        !sortingDropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getSortKey = () => {
    if (sortConfig.key === SortingType.date) {
      return `${sortConfig.key} (${
        sortConfig.direction === SortDirection.desc
          ? 'new to old'
          : 'old to new'
      })`;
    } else if (sortConfig.key === SortingType.name) {
      return `${sortConfig.key} (${
        sortConfig.direction === SortDirection.desc ? 'Z to A' : 'A to Z'
      })`;
    }
    return sortConfig.key;
  };

  return (
    <div ref={sortingDropdownRef}>
      <div className="mt-2 flex items-center justify-center">
        <div className="flex-1">
          <SearchInput
            searchValue={searchValue}
            onChangedSearch={onChangedSearch}
          />
        </div>
        <div className="relative flex items-center justify-center">
          <button
            className="ml-2"
            aria-label="Sort inspections"
            aria-haspopup="menu"
            aria-expanded={sortMenuOpen}
            onClick={() => setOpen(!sortMenuOpen)}
          >
            <Menu className="size-6" />
          </button>
          {sortMenuOpen && (
            <SortingMenu
              sortConfig={sortConfig}
              sortingItems={sortItems}
              handleSortChange={(s) => {
                setOpen(false);
                handleSortChange(s);
              }}
            />
          )}
        </div>
      </div>
      <div>
        <div className="mt-2 text-right text-sm text-inkMuted">
          Sorting by: {getSortKey()}
        </div>
      </div>
    </div>
  );
};

export default SearchWithSorting;
